/**
 * Default interval for polling/auto-refresh in milliseconds
 * 10 seconds
 */
export const DEFAULT_POLLING_INTERVAL_MS = 10000;

